<template>
    <div class="question-page">
      <div class="sidebar">
        <div class="wrapper">
          <div class="sidebar-header" style="text-align: center;">
            {{ exam.questions.length }} Questions
          </div>
    
          <div class="question-list">
            <div
              v-for="(e, index) in exam.questions"
              :key="index"
              :class="[
                'q-item',
                { active: index == questionId },
                { correct: getStatus(index) == 1 },
                { wrong: getStatus(index) == 0 }
              ]"
              @click="loadQuestion(e, index)">
              <span class="q-number">Q{{ index + 1 }}</span>
              <span class="q-status" v-if="getStatus(index) == 1">
                <i class="fas fa-check"></i>
              </span>
              <span class="q-status wrong" v-if="getStatus(index) == 0">
                <i class="fas fa-times"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="wrapper">
          <div class="content-header" style="justify-content: initial;">
            <div class="header-icon">
              <i class="fas fa-file-alt"></i>
            </div>
            <span>Question {{ questionId + 1 }}</span>
          </div>
          <div class="question-content" v-html="question.question"></div>
        </div>
      </div>
      <div class="operation">
        <div class="wrapper">
          <div class="operation-header">
            <div class="header-icon">
              <i class="fas fa-hand-pointer"></i>
            </div>
            <span>Select your answer</span>
          </div>
          <div class="options-list">
            <div
              v-for="(o, index1) in question.options"
              :key="index1"
              :class="[
                'option-item',
                { 
                  active: index1 == optionId,
                  correct: index1 == optionId && getStatus(questionId) == 1,
                  wrong: index1 == optionId && getStatus(questionId) == 0
                }
              ]"
              @click="setAnswer(question.id, index1)"
            >
              <span class="option-letter">{{ getAlpha(index1) }}</span>
              <div class="option-content" v-html="o"></div>
            </div>
          </div>
        </div>
      </div>
  
      <div id="drawer" class="drawer">
        <div class="drawer-content">
          <div class="drawer-header">
            <div class="header-icon">
              <i class="fas fa-lightbulb"></i>
            </div>
            <span>Question Analysis</span>
            <button class="close-btn" @click="closeDrawer">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="analysis-content" v-html="question.analysis"></div>
        </div>
      </div>
      <div id="overlay" class="overlay" @click="closeDrawer"></div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import util from '@/utils/util';
  
  export default {
    data() {
      return {
        question: {},
        questionId: 0,
        optionId: -1,
        map: new Map(),
        answerMap: new Map(),
        exam: {},
        favorite: [],
        userInfo:{}
      };
    },
    computed:{
      isFav(){
        var questionId = this.question.id;
        if(!questionId){
          return false;
        }
        var filterR = this.favorite.filter( r=> r == questionId);
        return filterR.length >0;
      }
    },
    mounted(){
      var user = localStorage.getItem('user');
      if(user && user != null && user != ''){
        var userObj = JSON.parse(user);
        this.userInfo = userObj;
      }
      else{
        location.href = '/';
        return;
      }
  
      this.loadFav();
  
      var year = util.getSearchString("year");
      var q = util.getSearchString("q");
  
      axios.get('https://ap.dctechonline.cn/data/problems/'+year+'/'+q+'.json?t='+new Date().getTime()).then(response => {
        var obj = {};
        obj.name = year +' '+q;
        obj.questions = response.data;
        this.exam = obj;
        this.loadQuestion(this.exam.questions[0], 0);
      }).catch(error => {
        console.error('Error fetching data:', error);
      });
    },
    methods: {
      async loadFav(){
        try {
          const userId = this.userInfo.UserId;
          const response = await axios.get(`https://apapi.dctechonline.cn/api/favorite/${userId}/0`);
          this.favorite = [];
          response.data.forEach( r=>{
            this.favorite.push(r.id);
          })
        } catch (err) {
        }
      },
      closeDrawer(){
        $('#drawer').removeClass('open');
        $('#overlay').removeClass('open');
      },
      openDrawer(){
        $('#drawer').toggleClass('open');
        $('#overlay').toggleClass('open');
      },
      setAnswer(id, a) {
        this.map.set(id, a);
        this.optionId = a;
        this.question = { ...this.question };
      },
      isFav(question){
        var questionId = question.Id;
        if(questionId){
          var filterR = this.favorite.filter( r=> r.Id = questionId);
          return filterR.length >0;
        }
        else{
          return false;
        }
      },
      getStatus(index) {
        const questionId = this.exam.questions[index];
        if (this.map.has(questionId) && this.answerMap.has(questionId)) {
          const correctAnswer = this.answerMap.get(questionId);
          const userAnswer = this.map.get(questionId);
          if (correctAnswer == userAnswer) {
            return 1;
          } else {
            return 0;
          }
        } else {
          return -1;
        }
      },
      addTofav(question){
        const id = question.id;
        const userId = this.userInfo.UserId;
  
        this.$http.post('https://apapi.dctechonline.cn/api/favorite', {
          questionId: id,
          userId: userId
        }).then(response => {
          this.loadFav();
        });
      },
      cancelFav(question){
        const id = question.id;
        const userId = this.userInfo.UserId;
        this.$http.delete(`https://apapi.dctechonline.cn/api/favorite/${userId}/${id}`).then(response => {
          this.loadFav();
        });
      },
      loadQuestion(q, index) {
        axios.get(`https://apapi.dctechonline.cn/api/question-real/${q}`).then((response) => {
          this.question = response.data;
          this.questionId = index;
          if (this.question && this.question.answer && this.question.answer[0]) {
            this.answerMap.set(q, this.question.answer[0]);
          }
          console.log(this.question);
          if (this.map.has(this.exam.questions[this.questionId])) {
            this.optionId = this.map.get(this.exam.questions[this.questionId]);
          } else {
            this.optionId = -1;
          }
        });
      },
      getAlpha(index) {
        switch (index) {
          case 0:
            return 'A';
          case 1:
            return 'B';
          case 2:
            return 'C';
          case 3:
            return 'D';
          case 4:
            return 'E';
          default:
            return '';
        }
      },
    }
  };
  </script>
  
  <style lang="scss">
  @import '@/styles/variables.scss';
  
  .question-page {
    position: fixed;
    left: 0;
    top: 56px;
    width: 100%;
    height: calc(100% - 56px);
    display: flex;
    background: $bg-primary;
  }
  
  .sidebar {
    width: 260px;
    height: 100%;
    padding: 12px;
  }
  
  .sidebar .wrapper {
    background: white;
    height: 100%;
    border-radius: 12px;
    box-shadow: $shadow-card;
    border: 1px solid $border-light;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  
  .sidebar-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 14px 20px;
    background: $primary-gradient;
    color: white;
    font-weight: 600;
    font-size: 14px;
  }
  
  .question-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    
    @include scrollbar-custom;
  }
  
  .q-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    margin-bottom: 6px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: $bg-secondary;
    border: 1px solid transparent;
    
    .q-number {
      font-weight: 500;
      font-size: 13px;
      color: $text-secondary;
    }
    
    .q-status {
      width: 20px;
      height: 20px;
      background: $success-color;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 10px;
      
      &.wrong {
        background: $danger-color;
      }
    }
    
    &:hover {
      background: rgba($primary-color, 0.1);
      border-color: rgba($primary-color, 0.3);
    }
    
    &.active {
      background: $primary-gradient;
      border-color: transparent;
      
      .q-number {
        color: white;
        font-weight: 600;
      }
    }
    
    &.correct {
      background: rgba($success-color, 0.1);
      border-color: $success-color;
      
      .q-number {
        color: $success-color;
      }
    }
    
    &.wrong {
      background: rgba($danger-color, 0.1);
      border-color: $danger-color;
      
      .q-number {
        color: $danger-color;
      }
    }
  }
  
  .content {
    height: 100%;
    flex: 1;
    padding: 12px;
    min-width: 400px;
  }
  
  .content .wrapper {
    background: white;
    height: 100%;
    padding: 20px;
    border-radius: 12px;
    box-shadow: $shadow-card;
    border: 1px solid $border-light;
    overflow: auto;
    display: flex;
    flex-direction: column;
    
    @include scrollbar-custom;
  }
  
  .content-header, .operation-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid $border-light;
    font-weight: 600;
    font-size: 15px;
    color: $primary-color;
    
    .header-icon {
      width: 28px;
      height: 28px;
      background: rgba($primary-color, 0.1);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }
  }
  
  .question-content {
    flex: 1;
    font-size: 14px;
    line-height: 1.8;
    color: $text-primary;
    
    p {
      margin-bottom: 16px;
    }
    
    code {
      background: $bg-secondary;
      padding: 2px 8px;
      border-radius: 4px;
      font-family: $font-mono;
      font-size: 13px;
      color: $primary-dark;
    }
    
    pre {
      background: $bg-dark;
      color: white;
      padding: 16px 20px;
      border-radius: 12px;
      overflow-x: auto;
      margin: 16px 0;
      
      code {
        background: transparent;
        padding: 0;
        color: inherit;
      }
    }
  }
  
  .operation {
    width: 480px;
    height: 100%;
    padding: 12px;
  }
  
  .operation .wrapper {
    background: white;
    height: 100%;
    padding: 20px;
    border-radius: 12px;
    box-shadow: $shadow-card;
    border: 1px solid $border-light;
    overflow-y: auto;
    
    @include scrollbar-custom;
  }
  
  .options-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .option-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: $bg-secondary;
    border: 2px solid transparent;
    
    .option-letter {
      width: 28px;
      height: 28px;
      background: white;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 13px;
      color: $text-secondary;
      flex-shrink: 0;
    }
    
    .option-content {
      font-size: 14px;
      line-height: 1.6;
      color: $text-secondary;
    }
    
    &:hover {
      background: rgba($primary-color, 0.05);
      border-color: rgba($primary-color, 0.3);
    }
    
    &.active {
      background: rgba($primary-color, 0.1);
      border-color: $primary-color;
      
      .option-letter {
        background: $primary-gradient;
        color: white;
      }
      
      .option-content {
        color: $text-primary;
      }
    }
    
    &.active.correct {
      background: rgba($success-color, 0.1);
      border-color: $success-color;
      
      .option-letter {
        background: $success-color;
      }
    }
    
    &.active.wrong {
      background: rgba($danger-color, 0.1);
      border-color: $danger-color;
      
      .option-letter {
        background: $danger-color;
      }
    }
  }
  
  .drawer {
    position: fixed;
    top: 0;
    right: -700px;
    width: 700px;
    max-width: 100%;
    height: 100%;
    background-color: white;
    transition: right 0.3s ease-in-out;
    z-index: 1000;
    overflow: auto;
    box-shadow: -10px 0 40px rgba(0, 0, 0, 0.1);
  }
  
  .drawer.open {
    right: 0;
  }
  
  .drawer-content {
    padding: 24px;
  }
  
  .drawer-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid $border-light;
    font-weight: 600;
    font-size: 16px;
    color: $primary-color;
    
    .header-icon {
      width: 32px;
      height: 32px;
      background: rgba($accent-color, 0.1);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $accent-color;
      font-size: 14px;
    }
    
    .close-btn {
      margin-left: auto;
      background: none;
      border: none;
      color: $text-muted;
      font-size: 18px;
      cursor: pointer;
      padding: 4px;
      transition: color 0.2s;
      
      &:hover {
        color: $text-primary;
      }
    }
  }
  
  .analysis-content {
    font-size: 14px;
    line-height: 1.8;
    color: $text-secondary;
    
    p {
      margin-bottom: 16px;
    }
    
    code {
      background: transparent;
      padding: 0;
      border-radius: 0;
      font-family: $font-mono;
      font-size: 13px;
      color: inherit;
    }
    
    pre {
      background: $bg-dark;
      color: white;
      padding: 16px 20px;
      border-radius: 12px;
      overflow-x: auto;
      margin: 16px 0;
    }
  }
  
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    z-index: 999;
    display: none;
  }
  
  .overlay.open {
    display: block;
  }
  
  table {
    border-collapse: collapse;
    margin: 10px 0;
    
    td, th {
      border: 1px solid $border-color;
      padding: 8px 12px;
      text-align: left;
    }
    
    th {
      background: $bg-secondary;
      font-weight: 600;
    }
  }
  </style>
